import { render } from "./PicturesSlider.vue?vue&type=template&id=9535f71e"
import script from "./PicturesSlider.vue?vue&type=script&lang=js"
export * from "./PicturesSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__